<template>
  <v-row
    no-gutters
    align="center"
    class="equipment-items__item"
  >
    <v-col
      cols="auto"
      class="pl-2"
    >
      <v-icon
        small
        class="sortHandle"
        style="cursor: grab"
      >
        drag_handle
      </v-icon>
    </v-col>
    <v-col>
      <validation-provider
        v-slot="v"
        rules="required"
        :vid="'items_label_'+index"
        name="Label"
      >
        <v-text-field
          v-model="itemDirty.label"
          placeholder="Enter item name/label"
          style="width: 100%"
          solo
          flat
          dense
          :name="'items_label_'+index"
          data-vv-as="item label"
          :error-messages="v.errors"
          :hide-details="!v.errors.length"
          @keyup.ctrl.enter="addItem"
          @keyup.ctrl.delete="removeItem()"
        />
      </validation-provider>
    </v-col>
    <v-col cols="auto">
      <v-text-field
        v-model="itemDirty.code"
        placeholder="Code"
        solo
        hide-details
        flat
        dense
        style="width: 100px"
        :name="'items_code_'+index"
        @keyup.ctrl.enter="addItem"
        @keyup.ctrl.delete="removeItem()"
      />
    </v-col>
    <v-col cols="auto">
      <validation-provider
        v-slot="{ errors }"
        rules="integer"
        name="Quantity"
      >
        <v-text-field
          v-model="itemDirty.quantity"
          :hide-details="!errors.length"
          placeholder="Qty"
          style="width: 60px"
          flat
          solo
          dense
          class="transparent"
          :error-messages="errors"
          @keyup.ctrl.enter="addItem"
          @keyup.ctrl.delete="removeItem()"
        />
      </validation-provider>
    </v-col>
    <v-col cols="auto">
      <validation-provider
        v-slot="v"
        rules="double:0"
        :vid="'items_purchase_price_'+index"
        name="Purchase Price"
      >
        <v-text-field
          v-model="itemDirty.unit_purchase_price"
          :suffix="currency"
          :name="'items_purchase_price_'+index"
          :class="{ 'font-weight-bold': purchasePriceDiffers }"
          placeholder="Purchase"
          style="width: 140px"
          class="v-text-field--light-suffix"
          solo
          flat
          dense
          type="number"
          autocomplete="off"
          data-vv-as="item purchase price"
          :error="purchasePriceDiffers"
          :error-messages="v.errors"
          :hide-details="!v.errors.length"
          @keyup.ctrl.enter="addItem"
          @keyup.ctrl.delete="removeItem()"
          @change="setUnitPurchasePrice"
        />
      </validation-provider>
    </v-col>
    <v-col cols="auto">
      <validation-provider
        v-slot="{ errors }"
        :vid="'items_sale_price_'+index"
        rules="double"
        name="Sale Price"
      >
        <v-text-field
          v-model="itemDirty.unit_sale_price"
          :suffix="currency"
          :name="'items_sale_price_'+index"
          placeholder="Sale"
          style="width: 140px"
          class="v-text-field--light-suffix"
          solo
          flat
          dense
          type="number"
          autocomplete="off"
          data-vv-as="item sale price"
          :error-messages="errors"
          :hide-details="!errors.length"
          @keyup.ctrl.enter="addItem"
          @keyup.ctrl.delete="removeItem()"
          @change="setUnitSalePrice"
        />
      </validation-provider>
    </v-col>
    <v-col style="flex: 0 0 50px">
      <span
        v-if="itemDirty.unit_sale_price > 0 && itemDirty.unit_purchase_price > 0"
        class="caption grey--text text--darken-2"
      >
        +{{ ((itemDirty.unit_sale_price - itemDirty.unit_purchase_price) / itemDirty.unit_sale_price) | percentage(1) }}
      </span>
    </v-col>
    <v-col
      class="px-2"
      cols="auto"
      style="flex: 0 0 32px"
    >
      <v-icon
        v-if="index > 0"
        color="red"
        small
        @click="removeItem(index)"
      >
        close
      </v-icon>
    </v-col>
  </v-row>
</template>

<script>
export default {
    name: 'ItemListRow',
    components: {
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      index: {
        type: Number,
        required: true
      },
      deletable: {
        type: Boolean,
        default: false
      },
      currency: {
        type: String,
        required: true
      },
      automaticMarkupPercentage: {
        type: Number,
        default: 0
      },
      automaticMarkupType: {
        type: String,
        default: 'margin'
      },
      automaticMarkupPurchase: {
        type: Boolean,
        default: false
      },
      automaticMarkupSale: {
        type: Boolean,
        default: false
      },
      automaticMarkupApply: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      itemDirty: {
        get: function () {
          return this.item
        },
        set: function (item) {
          this.$emit('update:item', item)
        }
      },
      purchasePriceFactor() {
        if (this.automaticMarkupType === 'margin') return (100 - this.automaticMarkupPercentage) / 100

        return 100 / (100 + this.automaticMarkupPercentage)
      },
      purchasePriceDiffers() {
        if (!this.itemDirty.unit_sale_price || !this.itemDirty.unit_purchase_price || this.purchasePriceFactor === 1) return false

        return Math.abs(1 - (Number(this.itemDirty.unit_sale_price * this.purchasePriceFactor) / this.itemDirty.unit_purchase_price)) > 0.001
      }
    },
    watch: {
      // 'itemDirty.unit_purchase_price': function () {
      //   this.calculateTotalPurchasePrice()
      // },
      'itemDirty.quantity': function () {
        this.calculateTotalSalePrice()
        this.calculateTotalPurchasePrice()
      },
      // 'itemDirty.unit_sale_price': function () {
      //   this.calculateTotalSalePrice()
      // },
      'discount': function () {
        this.calculateUnitPurchasePrice()
      },
      'automaticMarkupApply': function (value) {
        if (!value) return

        this.calculateUnitSalePrice()
        this.calculateUnitPurchasePrice()
      }
    },
    methods: {
      calculateUnitSalePrice() {
        if (!this.itemDirty.unit_purchase_price || !this.automaticMarkupPurchase) return

        this.itemDirty.unit_sale_price = Number(Number(this.itemDirty.unit_purchase_price / this.purchasePriceFactor).toFixed(2))
        this.calculateTotalSalePrice()
      },
      calculateUnitPurchasePrice() {
        if (!this.itemDirty.unit_sale_price || !this.automaticMarkupSale) return

        this.itemDirty.unit_purchase_price = Number(Number(this.itemDirty.unit_sale_price * this.purchasePriceFactor).toFixed(2))
        this.calculateTotalPurchasePrice()
      },
      calculateTotalSalePrice() {
        if (!this.itemDirty.quantity) return

        this.$nextTick(() => {
          this.itemDirty.sale_price = Number((this.itemDirty.quantity * this.itemDirty.unit_sale_price))

          this.$emit('calculate:sale-price')
        })
      },
      calculateTotalPurchasePrice() {
        if (!this.itemDirty.quantity) return

        this.$nextTick(() => {
          this.itemDirty.purchase_price = Number(this.itemDirty.quantity * this.itemDirty.unit_purchase_price)

          this.$emit('calculate:purchase-price')
        })
      },
      addItem() {
        this.$emit('item:add')
      },
      removeItem() {
        this.$emit('item:remove')
      },
      setUnitPurchasePrice() {
        this.calculateUnitSalePrice()
        this.calculateTotalPurchasePrice()
      },
      setUnitSalePrice(value) {
        this.calculateUnitPurchasePrice()
        this.calculateTotalSalePrice()
      }
    }
  }
</script>

<style scoped>

</style>
